import PotencialPersonList from './PotencialClientList';
import PotencialClientShow from './PotencialClientShow';

export const PotencialClient: object = {
  list: PotencialPersonList,
  show: PotencialClientShow
};

export default PotencialClient;